import { Component, createRef } from "react";
import withAuth from "../../components/withAuth";
import { withStyles } from "@mui/styles";
import { compose } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import "moment/locale/fr";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Checkbox from "@mui/material/Checkbox";
import TableWithoutPagination from "../../components/Table/TableWithoutPagination";
import { setAbsenceDetails } from "../../redux/absences/absencesActions";
import MenuItem from "@mui/material/MenuItem";
import Icon from "@mui/material/Icon/Icon";
import Button from "@mui/material/Button/Button";
import "./AbsenceTableForm.css";
import DatePicker from "../../components/Input/DatePicker";
import { FormControl, InputLabel } from "@mui/material";
import CustomizedSelect from "../../components/Input/CustomizedSelect";

const styles = (theme) => ({
	root: {
		width: "100%",
		marginTop: theme.spacing(3),
		overflowX: "auto",
	},
	table: {
		minWidth: 700,
	},
	row: {
		"&:nth-of-type(odd)": {
			backgroundColor: theme.palette.background.default,
		},
	},
});

class AbsenceTableForm extends Component {
	constructor(props) {
		super(props);
		this.table = createRef();

		this.renderDatePickerCell = this.renderDatePickerCell.bind(this);

		this.state = {
			columns: [
				{
					Header: "Détail",
					Cell: ({ row }) => {
						if (!this.props.absenceDetails[row.index]) return null;

						return (
							<div className="center col-lg-12 col-md-12 col-sm-12 col-12 row without-padding">
								<div className="col-lg-3 col-md-4 col-sm-12 col-12">
									<div className="row">
										<div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding disabled">
											{this.renderDatePickerCell(row, row.index)}
										</div>
									</div>
								</div>
								<div className="offset-lg-1 col-lg-3 col-md-4 col-sm-12 col-12 activity-type-cell">
									<div className="row">
										<div className="col-lg-2 col-md-2 col-sm-3 col-2 without-padding label-checkbox">
											<span>Matin</span>
										</div>
										<div className="col-lg-2 col-md-3 col-sm-3 col-3 without-padding">
											<Checkbox
												checked={this.props.absenceDetails[row.index].morning}
												onChange={this.morningCheckBoxChange.bind(this, row.index)}
												className="small-checkbox"
											/>
										</div>
										<div className="col-lg-8 col-md-7 col-sm-6 col-7 without-padding">
											<FormControl className="row">
												<InputLabel id="activityType-label">{"Type d'absence par défaut"}</InputLabel>
												<CustomizedSelect
													labelId="activityType-label"
													id="activityType"
													label="Type d'absence par défaut"
													inputProps={{ name: "activityType", id: "activityType" }}
													placeholder="Type d'absence par défaut"
													className="full_size"
																										onChange={this.onMorningActivityTypeChange.bind(this, row.index)}
													disabled={!this.props.absenceDetails[row.index].morning}
													value={
														this.props.absenceDetails[row.index].morning_type_id
															? this.props.absenceDetails[row.index].morning_type_id
															: ""
													}
												>
													{this.props.absences.activityTypes
														.filter(
															(at) =>
																at.report_type ===
																this.props.activeUser.weekly_report_type
														)
														.map((at) => {
															return (
																<MenuItem key={at.id} value={at.id}>
																	{at.name}
																</MenuItem>
															);
														})}
												</CustomizedSelect>
											</FormControl>
										</div>
									</div>
								</div>
								<div className="offset-lg-1 col-lg-3 col-md-4 col-sm-12 col-12 activity-type-cell">
									<div className="row">
										<div className="col-lg-2 col-md-2 col-sm-3 col-2 without-padding label-checkbox">
											<span>AM</span>
										</div>
										<div className="col-lg-2 col-md-3 col-sm-3 col-3 without-padding">
											<Checkbox
												checked={this.props.absenceDetails[row.index].afternoon}
												onChange={this.afternoonCheckBoxChange.bind(this, row.index)}
												className="small-checkbox"
											/>
										</div>
										<div className="col-lg-8 col-md-7 col-sm-6 col-7 without-padding">
											<FormControl className="row">
												<InputLabel id="solution-label">{"Type d'absence"}</InputLabel>
												<CustomizedSelect
													labelId="solution-label"
													id="solution"
													label="Type d'absence"
													inputProps={{ name: "activityType", id: "activityType" }}
													placeholder="Type d'absence"
													className="full_size"
																										onChange={this.onAfternoonActivityTypeChange.bind(this, row.index)}
													disabled={!this.props.absenceDetails[row.index].afternoon}
													value={
														this.props.absenceDetails[row.index].afternoon_type_id
															? this.props.absenceDetails[row.index].afternoon_type_id
															: ""
													}
												>
													{this.props.absences.activityTypes
														.filter(
															(at) =>
																at.report_type ===
																this.props.activeUser.weekly_report_type
														)
														.map((at) => {
															return (
																<MenuItem key={at.id} value={at.id}>
																	{at.name}
																</MenuItem>
															);
														})}
												</CustomizedSelect>
											</FormControl>
										</div>
									</div>
								</div>
							</div>
						);
					},
				},
			],
		};
	}

	morningCheckBoxChange(rowIndex, e) {
		let details = this.props.absenceDetails;
		let currentLine = details[rowIndex];
		currentLine.morning = e.target.checked;
		this.props.setAbsenceDetails(details, this.props.absenceCreationFields);
	}

	afternoonCheckBoxChange(rowIndex, e) {
		let details = this.props.absenceDetails;
		let currentLine = details[rowIndex];
		currentLine.afternoon = e.target.checked;
		this.props.setAbsenceDetails(details, this.props.absenceCreationFields);
	}

	onMorningActivityTypeChange(rowIndex, e) {
		let details = this.props.absenceDetails;
		let currentLine = details[rowIndex];
		currentLine.morning_type_id = e.target.value;
		this.props.setAbsenceDetails(details);
	}

	onAfternoonActivityTypeChange(rowIndex, e) {
		let details = this.props.absenceDetails;
		let currentLine = details[rowIndex];
		currentLine.afternoon_type_id = e.target.value;
		this.props.setAbsenceDetails(details);
	}

	onDateChange() {}

	renderDatePickerCell(row) {
		if (!this.props.absenceDetails[row.index]) {
			return;
		}

		let datePickerValue = this.props.absenceDetails[row.index].date;

		if (datePickerValue) {
			datePickerValue = moment(datePickerValue);
		}

		return (
			<div style={{ backgroundColor: "#fafafa" }}>
				<DatePicker
					value={datePickerValue}
					emptyLabel="La date est invalide"
					invalidDateMessage="La date est invalide"
					invalidLabel="La date est invalide"
					format="DD/MM/YYYY"
					className="col-lg-12 col-md-12 col-sm-12 col-12"
					onChange={this.onDateChange.bind(this)}
				/>
			</div>
		);
	}

	renderButtons(row) {
		if (row.row.original.id === 0) return <div></div>;

		return (
			<div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
				<Button
					onClick={this.removeAbsenceDetail.bind(this, row)}
					className="offset-lg-12 offset-md-12 offset-sm-12 offset-12 col-lg-12 col-md-12 col-sm-12 col-12 small-btn without-padding without-side-margin"
					color="primary"
				>
					<Icon className="small-icon">delete</Icon>
				</Button>
			</div>
		);
	}

	render() {
		return (
			<Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
				<CardContent
					className={this.props.readonly ? "disabled  without-side-padding" : " without-side-padding"}
				>
					<TableWithoutPagination
						ref={this.table}
						data={this.props.absenceDetails.filter((d) => !d.deleted)}
						columns={this.state.columns}
						contentEditable
					/>
				</CardContent>
			</Card>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		absences: state.absences,
		absenceDetails: state.absences.absenceDetails,
		absenceCreationFields: state.absences.absenceCreationFields,
		activeUser: state.activeUser,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setAbsenceDetails: (absenceDetails, absenceCreationFields) =>
			dispatch(setAbsenceDetails(absenceDetails, absenceCreationFields)),
	};
};

export default compose(withAuth, withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(AbsenceTableForm);
